exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "i.fa.fa-star[data-v-53f56fe6]{font-size:30px;color:#cfcfcf;margin:10px}i.fa.fa-star.filled[data-v-53f56fe6]{color:#f4cb00}", ""]);

// exports
